import React from 'react';
import { PricingTable } from '@clerk/react';

/**
 * Stagery-branded wrapper around Clerk's drop-in `<PricingTable />`.
 *
 * Pulls the orange `accent` (#f16e00) into Clerk's theme variables and aligns
 * fonts/radii with the rest of the app shell (rounded-2xl, system sans). Pure
 * appearance — no business logic. The flag-gate (off | new_signups_only |
 * all) is enforced one level up in `<SubscriptionPage />`.
 *
 * Plan IDs configured in the Clerk dashboard:
 *   solo_monthly · solo_yearly · kantoor_monthly · kantoor_yearly
 *   (`enterprise` is hidden / "Contact sales")
 *
 * Localization: nlNL is wired globally on `<ClerkProvider>` (see
 * `src/auth/ClerkProvider.tsx`), so plan/feature names + buttons render in
 * Dutch automatically — provided Sam labels them in Dutch in the dashboard.
 */
export const ClerkPricingTable: React.FC = () => {
  return (
    <div data-testid="clerk-pricing-table" className="stagery-clerk-pricing">
      <PricingTable
        appearance={{
          variables: {
            colorPrimary: '#f16e00',
            colorBackground: '#ffffff',
            borderRadius: '0.75rem',
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            fontSize: '14px',
          },
          elements: {
            // Keep the table edge-to-edge inside our existing 6xl container.
            rootBox: 'w-full',
            // Tighter card padding to match Stagery's other surfaces.
            card: 'rounded-2xl border border-black/8 shadow-none',
            // Use bold sans on plan headers (matches PlanCard.tsx).
            headerTitle: 'font-bold tracking-[-0.015em]',
            // CTA buttons — orange accent + lift on hover.
            primaryButton:
              'bg-accent hover:bg-accent-hover text-white shadow-[0_6px_18px_-6px_rgba(241,110,0,0.5)] hover:shadow-[0_10px_26px_-8px_rgba(241,110,0,0.55)] hover:-translate-y-0.5 transition-all',
          },
        }}
      />
    </div>
  );
};
